// extracted by mini-css-extract-plugin
export var box = "_6r-1";
export var checked = "_6r-2";
export var descriptionSpacer = "_6r-9";
export var disabled = "_6r-3";
export var icon = "_6r-6";
export var input = "_6r-0";
export var labelSpacer = "_6r-8";
export var medium = "_6r-5";
export var small = "_6r-4";
export var text = "_6r-7";